import { createStore, compose, applyMiddleware } from 'redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';
import thunk from 'redux-thunk';

// root reducer
import rootReducer from './reducers/index';

const store = createStore(
  rootReducer,
  {},
  compose(
    applyMiddleware(thunk)
    //,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);

export const history = syncHistoryWithStore(browserHistory, store);

export default store;
